<div
  class="tw-flex tw-flex-col tw-col-span-2 xl:tw-col-span-1 tw-h-full tw-max-h-[500px] tw-justify-end tw-text-dark-light-dynamic">
  <div
    [ngClass]="{ 'tw-hidden': !showChartOptions, 'tw-flex-col tw-relative': layoutService.isSmallScreen$ | async }"
    class="charts-actions chart-options-mobile tw-flex tw-flex-row tw-justify-between tw-mb-2 tw-flex-wrap tw-gap-y-2 tw-text-dark-light-dynamic">
    <div class="tw-flex tw-items-center tw-space-x-1"></div>
  </div>
  <div [style.height]="getChartContainerHeight()" class="tw-rounded tw-relative" [class.mat-card-shadow]="boxShadow">
    <div id="highchartsContainer-{{ chartId }}" class="tw-rounded"></div>
  </div>
</div>
